module.exports = __webpack_public_path__ + "static/img/map_henan.bfef4db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/map_henan.png
// module id = roVj
// module chunks = 0